import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return ( 
    <div class='px-6 pt-24 items-center flex justify-center flex-col-reverse lg:flex-row md:gap-28 gap-6
        md:max-w-[1690px] md:mx-auto md:px-[13.103%] md:py-20 md:mt-[100px]'>
      <div class=' w-full xl:w-1/2 relative pb-5 lg:pb-0'>
        <div class='relative'>
          <h1 class='heading-24 md:text-[48px] md:leading-[123%]'>
            Like Vincent, you're lost. Page not found!
          </h1>

          <Link to='/'>
            <button class='text-primary sm:w-full lg:w-auto text-sm my-5 border border-primary  py-4 px-8 text-center text-brand font-semibold rounded-lg'>
              Back to homepage
            </button>
          </Link>
        </div>
      </div>
      <div class='lg:[w-600px] lg:h-[360px]'>
        <img
          src='/assets/images/gif/nf.gif'
          alt='not-found'
          className='w-full h-full object-cover rounded'
        />
      </div>
    </div>
 
  );
};

export default NotFound;